import styled from "styled-components";

const Wrapper = styled.div`
    width: 260px;
    display: flex;
    flex-flow: column;
    flex: none;
    align-self: stretch;    
    visibility: ${props => (props.visible ? 'visible' : 'hidden')};
    >div {
        margin: 0;
        height : 100%;
    }
`;

export default Wrapper;